import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import BlogCategoryPost from "./BlogCategoryPost";
import ListCategories from "./ListCategories";
import firebase from "../../../../firebase";

function AllCategories(prop) {
  useEffect(() => {}, []);
  const [items, setItems] = useState([]);
  const ref = firebase.collection("/blog");
  function getData() {
    ref.onSnapshot((data) => {
      const item = [];
      data.forEach((doc) => {
        item.push(doc.data());
      });
      setItems(item);
    });
  }
  const allCategories = [
    "All",
    ...new Set(prop.name.map((item) => item.catagory)),
  ];
  const [menuItem, setMenuItem] = useState(prop.name);

  const [categories, setCategories] = useState(allCategories);

  const filterItem = (blogCategory) => {
    if (blogCategory === "All") {
      setMenuItem(prop.name);
      return;
    }
    const newItem = prop.name.filter((item) => item.catagory === blogCategory);
    setMenuItem(newItem);
  };

  return (
    <div>
      <Card className="recentCard">
        <ListCategories categories={categories} filterItem={filterItem} />
        <BlogCategoryPost Blogs={menuItem} />
      </Card>
    </div>
  );
}

export default AllCategories;
